/**
 * Input Schema of AuditoriaMotivo
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {AuditoriaMotivo} from '@/model/resource/AuditoriaMotivo'

/* TODO: review generated schema */
export class InputAuditoriaMotivoSchema extends Schema {
  readonly name = 'InputAuditoriaMotivo'

  readonly fieldSet: FieldSet<AuditoriaMotivo> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
